import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import saveNotice from "../../services/saveNotice";
import BackToHomeBtn from "../../components/BackToHomeBtn";
import { loaderActions } from "../../redux/slices/loadingSlice";
import { toast } from "react-toastify";
import { useState } from "react";
import { RxTimer } from "react-icons/rx";
import { SiFsecure, SiSpringsecurity } from "react-icons/si";
import { GiTakeMyMoney } from "react-icons/gi";
import requestPrivateTransfer from "../../services/requestPrivateTransfer";
import ApiReq_PrivateTransferReq from "../../types/ApiReq_PrivateTransferReq";
import { useTranslation } from "react-i18next";

const UpgradesPage = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const booking = useAppSelector((state) => state.booking);

  const onClickHandler = async () => {
    dispatch(loaderActions.showLoader());
    const requestBody: ApiReq_PrivateTransferReq = {
      notice: `Privattransferanfrage via MyLMX: Kalkulierter Aufpreis: ${booking.bookingUpgrades.transferPerPerson} Euro pro Person. Nettopreis Transfer: ${booking.bookingUpgrades.transferDbPrice}`,
      orderId: booking.orderId,
      orgunit: booking.orgunit,
      bookingName: booking.bookingUsername,
      bookingId: booking.bookingNumber,
      taskType: "Ancillaries",
      dbPrice: booking.bookingUpgrades.transferDbPrice,
      dbPax: booking.bookingUpgrades.transferPax,
      pricePerPerson: booking.bookingUpgrades.transferPerPerson,
    };

    const response = await requestPrivateTransfer(requestBody);

    if (response) {
      sessionStorage.setItem("lmxancillaries", "requested");
      dispatch(loaderActions.hideLoader());
      navigate("/confirmation", {
        state: {
          message:
            "Vielen Dank, wir buchen Ihr Upgrade und senden Ihnen eine neue Rechnung/Reisebestätigung.",
        },
      });
    } else {
      dispatch(loaderActions.hideLoader());
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="container mt-4">
      <BackToHomeBtn />
      <div className="row">
        <div className="col-12 col-lg-8">
          <h3>{t("privateTransfer.title")}</h3>
          <p className="mb-0">{t("privateTransfer.text1")}</p>

          <p className="mb-0">{t("privateTransfer.text2")}</p>
          <p>{t("privateTransfer.text3")}:</p>

          <div className="d-md-none mb-4">
            <div className="upgradesImage">
              <img src="images/privatetransfer.webp" alt="" className="h-100" />

              <div className="textOnUpgradesImage">
                <p className="text-warning fs-3 fw-bold mb-1">
                  {t("privateTransfer.perPerson")}
                </p>
                <p className="text-white fw-bolder display-4">
                  {booking.bookingUpgrades.transferPerPerson} €
                </p>
              </div>
            </div>
          </div>

          <div className="row g-3 row-cols-1 row-cols-lg-2">
            <div className="col">
              <div className="d-flex gap-2">
                <div>
                  <RxTimer className="display-4 text-info" />
                </div>

                <div>
                  <h5>{t("privateTransfer.efficiency")}:</h5>
                  <ul className="orangeList">
                    <li>{t("privateTransfer.efficiencyFeature1")}</li>
                    <li>{t("privateTransfer.efficiencyFeature2")}</li>
                    <li>{t("privateTransfer.efficiencyFeature3")}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex gap-2">
                <div>
                  <SiSpringsecurity className="display-4 text-info" />
                </div>

                <div>
                  <h5>{t("privateTransfer.privacy")}:</h5>
                  <ul className="orangeList">
                    <li>{t("privateTransfer.privacyFeature1")}</li>
                    <li>{t("privateTransfer.privacyFeature2")}</li>
                    <li>{t("privateTransfer.privacyFeature3")}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex gap-2">
                <div>
                  <SiFsecure className="display-4 text-info" />
                </div>

                <div>
                  <h5>{t("privateTransfer.security")}:</h5>
                  <ul className="orangeList">
                    <li>{t("privateTransfer.securityFeature1")}</li>
                    <li>{t("privateTransfer.securityFeature2")}</li>
                    <li>{t("privateTransfer.securityFeature3")}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex gap-2">
                <div>
                  <GiTakeMyMoney className="display-4 text-info" />
                </div>

                <div>
                  <h5>{t("privateTransfer.dailyPrices")}:</h5>
                  <ul className="orangeList">
                    <li>{t("privateTransfer.dailyPriceFeature1")}</li>
                    <li>{t("privateTransfer.dailyPriceFeature2")}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="confirm"
              onChange={() => setIsConfirmed((prev) => !prev)}
            />
            <label className="form-check-label" htmlFor="confirm">
              {t("privateTransfer.confirmText")}
            </label>
          </div>

          <div className="flex gap-5">
            {" "}
            <button
              className="btnRounded btnOrange"
              disabled={!isConfirmed}
              onClick={onClickHandler}
            >
              {t("privateTransfer.confirmButton", {
                price: booking.bookingUpgrades.transferPerPerson,
              })}
            </button>
          </div>

          <div className="d-flex justify-content-between"></div>
        </div>

        <div className="col-12 col-lg-4">
          <div className="upgradesImage d-none d-md-block">
            <img src="images/privatetransfer.webp" alt="" className="h-100" />

            <div className="textOnUpgradesImage">
              <p className="text-warning fs-3 fw-bold mb-1">
                {t("privateTransfer.perPerson")}
              </p>
              <p className="text-white fw-bolder">
                {t("privateTransfer.txtOnImage")}
              </p>
              <p className="text-white fw-bolder display-4">
                {booking.bookingUpgrades.transferPerPerson} €
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradesPage;
